import { Box, useTheme, Typography } from '@mui/material';
import { colorTheme } from '../theme';
import { CurrencyFormatterAllDecimals } from './helpers/commonFunctions/CurrencyFormater';

interface IProgressCircleProps {
  progress?: number | null | undefined;
  size?: number | null | undefined;
  value?: number;
}

const ProgressCircle = ({
  progress = 0.75,
  size = 40,
  value,
}: IProgressCircleProps): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const angle = progress && progress * 360;

  const formattedValue = CurrencyFormatterAllDecimals(value);
  const [integerPart, decimalPart] = formattedValue.toString().split('.');

  return (
    <Box
      sx={{
        background: `radial-gradient(${
          colors.primaryGreen[900]
        } 45%, transparent 46%),
        conic-gradient(transparent 0deg ${angle ?? 0}deg, ${
          colors.rgbGreen[600]
        } ${angle ?? 0}deg 360deg),
        ${colors.rgbGreen[400]}`,
        borderRadius: '50%',
        width: `${size ?? 0}px`,
        height: `${size ?? 0}px`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography>
        <Typography component="span" fontSize="0.9rem">
          {integerPart}
        </Typography>
        {decimalPart ? (
          <Typography component="span" fontSize="0.7rem">
            .{decimalPart}
          </Typography>
        ) : (
          ''
        )}
      </Typography>
    </Box>
  );
};

export default ProgressCircle;
